export default {
    cardsContainer: {
        margin: 'auto !important',
    },
}
